import { ChainlitContext } from '@chainlit/react-client';
import { useContext } from 'react';

interface CustomVoiceIconProps {
  className?: string;
}

export const CustomVoiceIcon = ({
  className = 'w-20 h-auto py-4',
}: CustomVoiceIconProps) => {
  const apiClient = useContext(ChainlitContext);
  return (
    <img
      src={apiClient.getCopilotAssetsEndpoint('asr_icon.png')}
      alt="voice"
      className={className}
    />
  );
};

